import { Columns, Divider, Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import PhoneScreenSVGComponent from "@shared/assets/images/PhoneScreen";
import { getPlatformName } from "@shared/helpers/getPlatformName";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { l } from "@shared/locales/i18n";

import * as styles from "./DownloadAuthenticator.styles";

interface Props {
  isModal?: boolean;
}

const DownloadAuthenticator = ({ isModal }: Props) => {
  const { t } = useTranslation();
  const { storePlatform } = useSharedGlobalConfig();

  const renderTitle = () => {
    if (isModal) {
      return (
        <Typography variant="h4" intention="neutral" colorIntensity="bold">
          {t(l.mfa.downloadAuthenticator.title)}
        </Typography>
      );
    }

    return (
      <div css={styles.header}>
        <Typography variant="h1" intention="neutral" colorIntensity="bold">
          {t(l.mfa.downloadAuthenticator.title)}
        </Typography>
      </div>
    );
  };

  return (
    <>
      {renderTitle()}
      <Columns>
        <Columns.Column columnWidth={2} phoneWidth={2}>
          <PhoneScreenSVGComponent css={styles.svgImage} />
        </Columns.Column>
        <Columns.Column columnWidth={10} phoneWidth={10}>
          <Typography fontWeight="bold" isMarginless>
            {t(l.mfa.step1)}
          </Typography>
          <Typography isMarginless>
            {t(l.mfa.downloadAuthenticator.downloadAnAuthenticatorApp)}
          </Typography>
          <Typography>
            <ul css={styles.authenticatorList}>
              <li>{t(l.mfa.downloadAuthenticator.googleAuthenticator)}</li>
              <li>{t(l.mfa.downloadAuthenticator.microsoftAuthenticator)}</li>
              <li>{t(l.mfa.downloadAuthenticator.lastPassAuthenticator)}</li>
              <li>{t(l.mfa.downloadAuthenticator.twilioAuthyAuthenticator)}</li>
            </ul>
          </Typography>
        </Columns.Column>
      </Columns>
      <Divider customCss={styles.separator} />
      <Columns>
        <Columns.Column columnWidth={2} phoneWidth={2}>
          <PhoneScreenSVGComponent css={styles.svgImage} />
        </Columns.Column>
        <Columns.Column columnWidth={10} phoneWidth={10}>
          <Typography fontWeight="bold" isMarginless>
            {t(l.mfa.step2)}
          </Typography>
          <Typography>
            {t(l.mfa.downloadAuthenticator.openTheApp, {
              platform: t(getPlatformName(storePlatform)),
            })}
          </Typography>
        </Columns.Column>
      </Columns>
    </>
  );
};

export { DownloadAuthenticator };
